
import { ReactNode } from "react";

interface AuthContainerProps {
  children: ReactNode;
}

export const AuthContainer = ({ children }: AuthContainerProps) => {
  return (
    <div className="flex flex-col min-h-[100dvh] bg-background overflow-auto">
      <div className="relative flex-1 w-full max-w-screen-xl mx-auto px-4 sm:px-6 flex items-center justify-center py-10">
        <div className="w-full max-w-md mx-auto">
          {children}
        </div>
      </div>
    </div>
  );
};
